<template>
  <div class="room-content">
    <Navbar :appTitle="appTitle"/>
    <Search
      ref="topSearch"
      class="search"
      placeholder="盘亏单编号 | 物品名称"
      :isScreen="true"
      :isType="true"
      :isAdd="true"
      @onSearch="onSearch"
      @onScreen="onScreen"
      @newBuild='newBuild'
      >
    </Search>
    <search-tag ref="SearchTag" @getCategory="getCategory"></search-tag>
    <!--分页列表 -->
    <div class="listBox">
      <pageList ref="pageList" :checkedShow="false" :columns="columns" :minLen="3" :listUrl="listUrl" @handleList="handleList">
        <div slot="foot" slot-scope="{item}" class="operateBox">
          <div class="delBtn" v-if="item.isArchive == 0 && !item.sourceId" @click.stop="handleDelete(item)">删除</div>
          <div class="pubBtn" v-if="item.isArchive == 0" @click.stop="handleCArchive(item)">归档</div>
        </div>
      </pageList>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
import Search from "@/components/search";
import SearchTag from "./SearchTag";
import pageList from "@/components/pageList";
import { Dialog } from "vant";
import {
  deleteWmsProOrLoss,
  recordArchive
} from "@/api/inventoryOrder";

export default {
  name: "inventoryLoss",
  components: {
    Navbar,
    Search,
    SearchTag,
    pageList
  },
  data() {
    return {
      appTitle: "盘亏单",
      listUrl: "/wmsProfitOrLoss/queryProOrLossForPage?operateType=4", //列表接口
      columns: {
        titleKey: "taskCode", //标题
        content: [
          //内容
          {
            name: "盘盈明细",
            key: ["detailNum"],
          },
          {
            name: "盘亏数",
            key: ["inventoryCountText"],
          },
        ],
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.SearchTag.showSearchTag) {
      this.appTitle = this.$route.query.navTitle;
      this.$refs.SearchTag.showSearchTag = false;
      next(false);
    } else {
      next();
    }
  },
  mounted() {
    this.searchQuery();
  },
  methods: {
    // 搜索
    searchQuery(searchObj) {
      let params = {
        ...searchObj,
      };
      this.$refs.pageList.searchQuery(params);
    },
    // 模糊查询
    onSearch(v) {
      this.keyword = v;
      let searchObj = {
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
    },
    // 更多查询页面
    onScreen() {
      this.appTitle = "更多筛选";
      this.keyword = this.$refs.topSearch.value;
      this.$refs.SearchTag.showModal(this.keyword);
    },
    getCategory(sureObj) {
      this.appTitle = "盘亏单";
      this.keyword = sureObj.keyword;
      this.$refs.topSearch.value = sureObj.keyword;
      this.searchQuery(sureObj);
    },
    // 新建
    newBuild() {
      this.$router.push({
        path: "/inventoryLossForm",
      });
    },
    //详情
    handleList(id, item, type) {
      this.$router.push({
        path: "/inventoryLossDetail",
        query: {
          id: item.id,
        },
      });
    },
    //删除
    handleDelete(e) {
      Dialog.confirm({
        title: '确定删除盘亏单吗？',
        message: '盘亏单删除，单据内物品、批号及盘点库位的库存同步对应减少',
        confirmButtonColor: '#2b85e4'
      }).then(() => {
        deleteWmsProOrLoss({id: e.id, operateType: 4}).then((res) => {
          if (res.success) {
            this.$toast('盘亏单删除成功');
            this.searchQuery()
          } else {
            this.$toast(res.message);
          }
        });
      }).catch(() => {

      })
    },
    // 归档
    handleCArchive(e) {
      Dialog.confirm({
        title: '确认归档吗？',
        message: '确定后，单据将无法删除',
        confirmButtonColor: '#2b85e4'
      }).then(() => {
        recordArchive({entityCode:'WMS_WAREHOUSE_INVENTORY_LOSS', ids: e.id}).then((res) => {
          if (res.success) {
            this.$toast('盘亏单归档成功');
            this.searchQuery()
          } else {
            this.$toast(res.message);
          }
        });
      }).catch(() => {

      })
    },
  },
};
</script>
<style lang="less" scoped>
.flex(@jc,@ai,@fd:row) {
  display: flex;
  justify-content: @jc;
  align-items: @ai;
  flex-direction: @fd;
}
.search {
  position: fixed;
  top: 93px;
  z-index: 98;
  width: 100%;
}
.listBox {
  margin-top: 120px;
  overflow-y: hidden;
}
.room-content {
  height: 100vh;
  overflow-y: scroll;
  .serach {
    height: 0.33rem;
    background: #f2f2f6;
    border-radius: 0rem;
    margin-bottom: 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 0.33rem;
    padding: 0.1rem 0.12rem;
    .placeh {
      font-size: 0.16rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 0.23rem;
    }
    .icon {
      width: 0.15rem;
      height: 0.16rem;
    }
  }
}
.operateBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-right: 3px;
  font-size: 28px;
  font-weight: 500;
  color: #1890ff;
}
.label {
  margin-left: -6px;
  margin-top: -20px;
  span {
    height: 32px;
    background: #f0f6fe;
    color: #1890ff;
    margin-right: 20px;
    padding: 6px 16px;
    font-size: 22px;
    border-radius: 6px;
  }
  .UN {
    background-color: #e6e6e6;
    color: #969696
  }
  .ING {
    background: #f0f6fe;
    color: #1890ff;
  }
  .PENDING {
    background-color: #fff5e6;
    color: #ff9900
  }
  .FINISH {
    background-color: #e8f9f0;
    color: #19be6b
  }
}
.pubBtn {
  margin-right: 20px;
  &:nth-last-child(1) {
    margin-right: 0;
  }
}

.delBtn{
  color: red;
  margin-right: 20px;
}
</style>
